import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class EmpresaTributacaoValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.aliquotaicms) || !Util.validatePorcentagem(model.aliquotaicms)) {
			refs.aliquotaicmsInput.focusedOut = true;
			validated = false;
		}

		if (Util.isNull(model.calculaipi)) {
			refs.calculaipiInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.calculast)) {
			refs.calculastInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.tipoempresa)) {
			refs.tipoempresaInput.focusedOut = true;
			validated = false;
		}
        if (Util.isNull(model.tipocalcjuros)) {
			refs.tipoCalcJurosInput.focusedOut = true;
			validated = false;
		}
		
		return validated;
	}
}
